'use strict';

var React = require('react');

var SvgSocialPostMajor = function SvgSocialPostMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.5a.75.75 0 0 1 .75.75v1.25a.75.75 0 0 1-1.5 0v-1.25a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.78 5.53 1-1a.75.75 0 0 0-1.06-1.06l-1 1a.75.75 0 0 0 1.06 1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.75a3.25 3.25 0 0 1 3.25-3.25h4a.75.75 0 0 0 0-1.5h-4a4.75 4.75 0 0 0-4.75 4.75v.75c0 2.1 1.362 3.88 3.25 4.508v1.992a.75.75 0 0 0 1.196.603l3.178-2.353h1.626a4.75 4.75 0 0 0 4.75-4.75.75.75 0 0 0-1.5 0 3.25 3.25 0 0 1-3.25 3.25h-1.873a.75.75 0 0 0-.447.147l-2.18 1.614v-1.081a.75.75 0 0 0-.61-.737 3.251 3.251 0 0 1-2.64-3.193v-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.25a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25 7.75a.75.75 0 0 0 0-1.5h-1.25a.75.75 0 0 0 0 1.5h1.25Z"
  }));
};
SvgSocialPostMajor.displayName = "SocialPostMajor";

exports.SvgSocialPostMajor = SvgSocialPostMajor;
